import React, { useCallback, useState } from "react";
import { Box, Paper, Table, TableBody, TableContainer, TableHead, TableRow, Typography } from "@material-ui/core";
import Preloader from "../../Common/Preloader";
import { useTranslation } from "react-i18next";
import PayoutTableRow from "./payout-table-row";
import StyledTableCell from "./styled-table-sell";
import { useStyles } from "./styles";
import { useFindPayoutsQuery } from "../../../api/payout";
import { Pagination } from "@material-ui/lab";

interface PaymentsListProps {
  hall_id: number;
}
const PaymentsList: React.FC<PaymentsListProps> = ({ hall_id }) => {
  const classes = useStyles();
  const [t] = useTranslation();
  const form: PaymentFormFind = { hall_id };
  const [page, setPage] = useState(1);
  const { data: payments, isLoading } = useFindPayoutsQuery({ data: form, page });
  const handlePage = useCallback(((_event: React.ChangeEvent<unknown>, page: number) => setPage(page)), []);
  return <Box display="flex" flexDirection="column" justifyContent="space-between" style={{ width: "100%" }}>
    {!payments || isLoading ? (
      <Preloader />
    ) : (
      <>
        <TableContainer component={Paper} className={classes.container}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <StyledTableCell align="center">{t("ru.payment.fields.id")}</StyledTableCell>
                <StyledTableCell align="center">{t("ru.payment.fields.tableId")}</StyledTableCell>
                <StyledTableCell align="center">{t("ru.payment.fields.tableLogin")}</StyledTableCell>
                <StyledTableCell align="center">{t("ru.payment.fields.type")}</StyledTableCell>
                <StyledTableCell align="center">{t("ru.payment.fields.sum")}</StyledTableCell>
                <StyledTableCell align="center">{t("ru.payment.fields.status")}</StyledTableCell>
                <StyledTableCell align="center">{t("ru.payment.fields.service")}</StyledTableCell>
                <StyledTableCell align="center">{t("ru.payment.fields.data")}</StyledTableCell>
                <StyledTableCell align="center">{t("ru.payment.fields.history")}</StyledTableCell>
                <StyledTableCell align="center">{t("ru.payment.fields.created_at")}</StyledTableCell>
                <StyledTableCell align="center"></StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody className={classes.list}>
              {payments.data.map(payment => <PayoutTableRow key={payment.id} hall_id={hall_id} payment={payment} />)}
            </TableBody>
          </Table>
          <Pagination count={payments.pagination.pageCount} onChange={handlePage} variant="outlined" shape="rounded" />
        </TableContainer>
        {payments.data.length === 0 && <Box style={{ width: "100%", padding: "25px 0" }} display="flex" justifyContent="center">
          <Typography>{t("ru.common.is_absent")}</Typography>
        </Box>}
      </>
    )}
  </Box>;
}

export default PaymentsList
